import React, { useState, useRef, useEffect } from "react";
import styles from "./dayRevenueCard.module.css";
import InfoIcon from "../../../assets/icons/info-icon.svg";
import { formatNumberToCurrency } from "../../../utils/formatter";

const DayRevenueCard = ({ 
  dayData = null, 
  icon, 
  title = "Dia do Mês com Maior Faturamento",
  explanation = "",
  code
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const popRef = useRef(null);

  // Log para debug
  console.log(`DayRevenueCard [${title}]:`, dayData);
  
  const hasNoData = !dayData || (dayData.diaMes === undefined && dayData.valorRecebido === undefined && dayData.valor === undefined);

  useEffect(() => {
    if (showPopover && popRef.current) {
      const rect = popRef.current.getBoundingClientRect();
      if (rect.right > window.innerWidth - 8) {
        popRef.current.style.left = `-${rect.width + 8}px`;
      } else {
        popRef.current.style.left = '100%';
      }
    }
  }, [showPopover]);

  if (hasNoData) {
    return (
      <div className={styles.dayRevenueCard}>
        {code && <span className={styles.code}>{code}</span>}
        <img src={icon} alt="" className={styles.icon} />
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <h6 className={styles.title}>{title}</h6>
            {explanation && (
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  src={InfoIcon}
                  alt="Informação"
                  style={{ cursor: 'pointer', width: 14, height: 14 }}
                  onClick={() => setShowPopover(prev => !prev)}
                />
                {showPopover && (
                  <div
                    ref={popRef}
                    className={styles.popover}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: '100%',
                      marginLeft: 8,
                      zIndex: 100,
                    }}
                  >
                    <p style={{ margin: 0 }}>{explanation}</p>
                    <button
                      type="button"
                      className={styles.closeBtn}
                      onClick={() => setShowPopover(false)}
                    >
                      Fechar
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          <h2 className={styles.value}>Nenhum dado encontrado</h2>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dayRevenueCard}>
      {code && <span className={styles.code}>{code}</span>}
      <img src={icon} alt="" className={styles.icon} />
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <h6 className={styles.title}>{title}</h6>
          {explanation && (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src={InfoIcon}
                alt="Informação"
                style={{ cursor: 'pointer', width: 14, height: 14 }}
                onClick={() => setShowPopover(prev => !prev)}
              />
              {showPopover && (
                <div
                  ref={popRef}
                  className={styles.popover}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    marginLeft: 8,
                    zIndex: 100,
                  }}
                >
                  <p style={{ margin: 0 }}>{explanation}</p>
                  <button
                    type="button"
                    className={styles.closeBtn}
                    onClick={() => setShowPopover(false)}
                  >
                    Fechar
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <h2 className={styles.value}>
          {formatNumberToCurrency(
            dayData.valorRecebido !== undefined 
              ? dayData.valorRecebido 
              : dayData.valor !== undefined
                ? dayData.valor
                : 0
          )}
        </h2>
        <p className={styles.dayText}>Dia {dayData.diaMes}</p>
      </div>
    </div>
  );
};

export default DayRevenueCard;
